// extracted by mini-css-extract-plugin
module.exports = {"balance":"_8287316"};